import { render } from "./user-information.vue?vue&type=template&id=57ef4190&scoped=true"
import script from "./user-information.vue?vue&type=script&lang=js"
export * from "./user-information.vue?vue&type=script&lang=js"

import "./user-information.vue?vue&type=style&index=0&id=57ef4190&scoped=true&lang=css"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ef4190"]])

export default __exports__